// CLASSES
import AppConfig from "@classes/AppConfig";


export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	if (state.fields.radio_autogiro_source === "konto") {
		const replacedAccountNo = state.fields.customer_autogiro_bankno.split(" ").join("");
		if (replacedAccountNo.length <= 5 || state.fields.customer_autogiro_bank.length === 0) {
			return false;
		}

		if (!state.fields.skipBankAccountValidation && state.fields.shouldValidateBankAccount && (!state.validFields.customer_autogiro_bankno || !state.validFields.customer_autogiro_bank_clearingno)) {
			return false;
		}
	}
	else {
		if (state.fields.customer_autogiro_custno.length < 5) {
			return false;
		}
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Autogiro/no-amount/Autogiro.fulfillment.js